import { AsymmetricMessagePayloadType, } from '@standardnotes/models';
import { Result } from '@standardnotes/domain-core';
export class SendOwnContactChangeMessage {
    constructor(encryptMessage, sendMessage) {
        this.encryptMessage = encryptMessage;
        this.sendMessage = sendMessage;
    }
    async execute(params) {
        const message = {
            type: AsymmetricMessagePayloadType.SenderKeypairChanged,
            data: {
                recipientUuid: params.contact.contactUuid,
                newEncryptionPublicKey: params.senderNewKeyPair.publicKey,
                newSigningPublicKey: params.senderNewSigningKeyPair.publicKey,
            },
        };
        const encryptedMessage = this.encryptMessage.execute({
            message: message,
            keys: {
                encryption: params.senderOldKeyPair,
                signing: params.senderOldSigningKeyPair,
            },
            recipientPublicKey: params.contact.publicKeySet.encryption,
        });
        if (encryptedMessage.isFailed()) {
            return Result.fail(encryptedMessage.getError());
        }
        const sendMessageResult = await this.sendMessage.execute({
            recipientUuid: params.contact.contactUuid,
            encryptedMessage: encryptedMessage.getValue(),
            replaceabilityIdentifier: undefined,
        });
        return sendMessageResult;
    }
}
